import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const STORY_HERO =
    "https://images.unsplash.com/photo-1500595046743-cd271d694d30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export default function OurStory() {
    return (
        <main className="bg-[#F6F1E7] min-h-screen pb-24" data-testid="our-story-page">
            <section className="relative h-[70vh] min-h-[480px] overflow-hidden flex items-end">
                <img src={STORY_HERO} alt="British cattle grazing at golden hour" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C]/85 via-[#0B0B0C]/30 to-[#0B0B0C]/45" />
                <div className="relative z-10 max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 pb-16 w-full">
                    <p className="eyebrow text-[#C9B37A]">Our Story</p>
                    <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl font-medium text-[#F6F1E7] mt-3 leading-tight">
                        Real British beef.
                        <br />
                        <span className="italic font-normal">Raised with care. Crafted with patience.</span>
                    </h1>
                </div>
            </section>

            <div className="max-w-[760px] mx-auto px-5 sm:px-8 pt-20 space-y-16">
                <Reveal>
                    <p className="font-serif-display text-2xl sm:text-3xl leading-snug text-black/80">
                        British Steak Co. began with a simple frustration: the finest beef in the world is raised on
                        British farms, yet almost all dried beef sold here is anonymous, imported and drowned in seasoning.
                    </p>
                </Reveal>

                <Reveal>
                    <p className="eyebrow text-[#8C6A3D] mb-5">The Belief</p>
                    <p className="text-base text-black/65 leading-relaxed">
                        We believe provenance is not a marketing word. It is a name, a farm, a field. We work with five
                        British farming families — in the Highlands, the Dales, the Beacons, Staffordshire and Devon —
                        who raise native breeds slowly, on pasture, the way their grandparents did.
                    </p>
                    <p className="text-base text-black/65 leading-relaxed mt-5">
                        Every batch we make comes from a single farm on a single day. The batch number on your pack traces
                        back to the very field your beef was raised on.
                    </p>
                    <p className="text-base text-black/65 leading-relaxed mt-5">
                        And one thing we are quietly uncompromising about: our beef is 100% British and traditionally
                        processed to the highest welfare standards — never halal. It is a simple promise of provenance,
                        printed on every pack.
                    </p>
                </Reveal>

                <Reveal>
                    <p className="eyebrow text-[#8C6A3D] mb-5">The Craft</p>
                    <p className="text-base text-black/65 leading-relaxed">
                        Whole cuts — sirloin, ribeye, fillet, bavette, picanha — are hand-trimmed by master butchers,
                        seasoned with nothing but Cornish sea salt, and dried for thirty hours on beechwood racks. No sugar.
                        No smoke flavouring. No preservatives. The drying is the preservation, as it has been for centuries.
                    </p>
                    <p className="text-base text-black/65 leading-relaxed mt-5">
                        The result is a premium British dried beef with the depth of a great steak and the elegance of fine
                        charcuterie — something closer to a single malt than a snack.
                    </p>
                </Reveal>

                <Reveal>
                    <blockquote className="border-l-2 border-[#C9B37A] pl-8 py-2">
                        <p className="font-serif-display text-2xl italic text-black/80 leading-snug">
                            “When the beef is exceptional, you get out of its way.”
                        </p>
                    </blockquote>
                </Reveal>

                <Reveal className="text-center pt-4">
                    <div className="flex flex-wrap justify-center gap-4">
                        <Link to="/farms" className="btn-luxe btn-green" data-testid="story-farms-button">
                            Meet The Farmers
                        </Link>
                        <Link to="/shop" className="btn-luxe btn-outline-dark" data-testid="story-shop-button">
                            Shop Collection
                        </Link>
                    </div>
                </Reveal>
            </div>
        </main>
    );
}
